module.exports = __webpack_public_path__ + "img/ganni-north.2ab40094.jpg";